"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResumeAuctionResponseDtoAuctionStatusEnum = void 0;
exports.instanceOfResumeAuctionResponseDto = instanceOfResumeAuctionResponseDto;
exports.ResumeAuctionResponseDtoFromJSON = ResumeAuctionResponseDtoFromJSON;
exports.ResumeAuctionResponseDtoFromJSONTyped = ResumeAuctionResponseDtoFromJSONTyped;
exports.ResumeAuctionResponseDtoToJSON = ResumeAuctionResponseDtoToJSON;
exports.ResumeAuctionResponseDtoToJSONTyped = ResumeAuctionResponseDtoToJSONTyped;
/**
 * @export
 */
exports.ResumeAuctionResponseDtoAuctionStatusEnum = {
    ToBeStarted: 'to_be_started',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Cancelled: 'cancelled'
};
/**
 * Check if a given object implements the ResumeAuctionResponseDto interface.
 */
function instanceOfResumeAuctionResponseDto(value) {
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('resumedAt' in value) || value['resumedAt'] === undefined)
        return false;
    if (!('auctionStatus' in value) || value['auctionStatus'] === undefined)
        return false;
    return true;
}
function ResumeAuctionResponseDtoFromJSON(json) {
    return ResumeAuctionResponseDtoFromJSONTyped(json, false);
}
function ResumeAuctionResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listingId': json['listingId'],
        'resumedAt': (new Date(json['resumedAt'])),
        'auctionStatus': json['auctionStatus'],
    };
}
function ResumeAuctionResponseDtoToJSON(json) {
    return ResumeAuctionResponseDtoToJSONTyped(json, false);
}
function ResumeAuctionResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listingId': value['listingId'],
        'resumedAt': value['resumedAt'].toISOString(),
        'auctionStatus': value['auctionStatus'],
    };
}
